export default {
    Active(state, val){state.access = val},    
    set_asideStorage(state, val){ state.asideStorage = val; },
    settypeStep(state, val){ state.typeStep = val; },
}
